import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureFilmInteractionsComponent } from './feature-film-interactions.component';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { UserCtaDirective } from '@usheru-hff/shared/utils-authentication';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [CommonModule, ButtonModule, TooltipModule, FontAwesomeModule, UserCtaDirective],
  declarations: [FeatureFilmInteractionsComponent],
  exports: [FeatureFilmInteractionsComponent],
  providers: []
})
export class FeatureFilmInteractionsModule {}
